import { Headphones } from "lucide-react";
import { noiseLevel } from "@/lib/micCalibration";
import { SKILLS } from "@/data/parts";

// Noisy room before the test + speaking clearly behind the other skills
export const needsHeadset = (e) => {
  if (e.roomNoise == null || noiseLevel(e.roomNoise) === "ok" || e.skills?.speaking == null) return false;
  const others = SKILLS.filter((s) => s !== "speaking").map((s) => e.skills[s]).filter((v) => v != null);
  return others.length > 0 && e.skills.speaking <= others.reduce((a, b) => a + b, 0) / others.length - 3;
};

const TIPS = [
  ["Pick a headset with a boom mic", "A mic that sits a few centimetres from your mouth picks up your voice far more than the room."],
  ["Look for noise-cancelling on the microphone", "Often called an \"ENC\" or \"noise-cancelling mic\". Noise-cancelling for the earphones alone doesn't help scoring."],
  ["Prefer USB or wired over Bluetooth", "Bluetooth headsets switch to a low-quality mic mode during calls, which blurs pronunciation."],
  ["Test in the quietest room you can", "Close doors and windows, switch off fans and TV, and keep about two fingers' width between mic and mouth."],
];

export const HeadsetTip = ({ entry }) => (
  <div data-testid="headset-tip" className="mt-6 rounded-2xl border border-amber-300/40 bg-amber-50 p-6 text-amber-950 shadow-xl">
    <div className="flex items-start gap-3">
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-amber-200 text-amber-800"><Headphones className="h-5 w-5" /></span>
      <div>
        <h3 className="font-display text-lg font-bold">Background noise may have lowered your speaking score</h3>
        <p className="mt-1 text-sm text-amber-900">Your room measured {noiseLevel(entry.roomNoise) === "bad" ? "very noisy" : "somewhat noisy"} before this test, and speaking ({entry.skills.speaking}) came in below your other skills. A headset mic usually fixes this.</p>
      </div>
    </div>
    <ul className="mt-4 grid gap-3 sm:grid-cols-2">
      {TIPS.map(([t, d]) => <li key={t} className="rounded-xl bg-white/70 p-3 text-sm"><b className="block text-amber-900">{t}</b><span className="text-xs text-amber-800">{d}</span></li>)}
    </ul>
  </div>
);
